import cuid from "cuid";
import { camelCase, omit } from "lodash";

export default {
  name: "IndicatorsData",
  props: {
    audit: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    formattedIndicators() {
      const obj = {};
      Object.entries(omit(this.audit.data, "reviews")).map(([k, v]) => {
        if (k === "number_of_photos") {
          obj.numberOfPhotos = {
            name: k,
            id: cuid(),
            value: v.last_value,
            type: v.last_value ? "success" : "error"
          };
          return;
        }

        if (k === "phone_number") {
          obj.phoneNumber = {
            name: k,
            id: cuid(),
            value: v.last_value
              ? this.$t("message.common.added")
              : this.$t("message.common.none"),
            type: v.last_value ? "success" : "error"
          };
          return;
        }

        obj[camelCase(k)] = {
          name: k,
          id: cuid(),
          value: v.last_value
            ? this.$t("message.common.added")
            : v.last_value === 0
            ? v.last_value
            : this.$t("message.common.none"),
          type: v.last_value ? "success" : "error"
        };
      });

      obj.avgRateOnMainPage = {
        name: "avg_rate_on_main_page",
        id: cuid(),
        value:
          this.audit.avg_rate_on_main_page.last_value ||
          this.$t("message.common.noData"),
        info: this.$t("message.visibility.GMBSummary.avgRateInfo"),
        type:
          this.audit.avg_rate_on_main_page.last_value &&
          this.audit.avg_rate_on_main_page.last_value > 4.0
            ? "success"
            : "error"
      };

      obj.reviewsRating = {
        name: "reviews_rating",
        id: cuid(),
        value:
          this.audit.reviews_rating.last_value ||
          this.$t("message.common.noRatings"),
        type:
          this.audit.reviews_rating.last_value &&
          this.audit.reviews_rating.last_value > 3
            ? "success"
            : "error"
      };

      obj.reviewers = {
        name: "reviewers",
        id: cuid(),
        value: this.audit.reviewers.last_value,
        type: this.audit.reviewers.last_value ? "success" : "error"
      };

      return obj;
    }
  },

  render() {
    return this.$scopedSlots.default({
      formattedIndicators: this.formattedIndicators
    });
  }
};
